export const EMAILJS_SERVICE_ID = 'service_xpuv6cv';
export const EMAILJS_TEMPLATE_ID = 'template_6elz1jq';
export const EMAILJS_PUBLIC_KEY = 'QGz0dganSpBj-Y0bN';